module.exports = __webpack_public_path__ + "static/media/74.d751ac26.png";